<template>
    <div class="about-box">
        <div class="banner"></div>
        <div class="about">
          <h3>ABOUT US</h3>
          <h4>Your Best Choice of E-Commerce Warehousing Solutions</h4>
          <div>
            <p>Grand Channel Incorporated (Grand Channel) is a 192,000-square-feet rapidly growing commercial warehouse
established in 2018. Located in Chino at South California, west coast of USA, Grand Channel takes the
geographical advantage to control cost and promote efficency.</p>
            <p>Born for Cross-Border E-Commerce (CBEC) solutions, Grand Channel has developed warehousing solution
network covering the entire North America area. This network easily handles hundreds of containers and trailers
in and out from Los Angeles, Oakland, Chicago, New York, and other cities close to busy international ports. In
order to achieve the most comprehensive reliable, high quality, cost-effective, quick response and flexible service,
Grand Channel always selects partners carefully, from “First Trip” forwarding until “Last Mile” shipping, to meet
the most finicky customer’s satisfaction. At the same time, Grand Channel applies multiple technological systems
to improve user’s experience, making warehouse management as simple as ABC. </p>
            <p>Based on the spirit of keeping innovative and pioneering in the competitive market, Grand Channel has been
expending our business and enhancing our reputation gradually with the consistent focus on improving service
quality for customers. Here in Grand Channel, we improve organization management with an open and global
sight, and has built up an elite management team with favorable iamge. </p>
            <p>Service quality is paramount; Customer satisfaction is our priority. As a professional ecommerce warehousing
solutions leader, Grand Channel is distinguished like a brilliant sun rising from deep sea, and flames the sky all the
time.  </p>
          </div>
        </div>
        <div class="strengths">
          <h3>OUR STRENGTHS</h3>
          <h4>Four Top Reasons for Choosing Grand Channel Warehouse</h4>
          <ul>
            <li>
              <span></span>
              <div>
                <span>Cost-Efficiency</span>
                <p>Grand Channel is aimed at minimizing costomer’s expenses incurred while maximizing
warehousing service quality.</p>
              </div>
            </li>
            <li>
              <span></span>
              <div>
                <span>Technological Systems</span>
                <p>Working together and moving on to concerted actions, our WMS, Shipping Center and
OMS systems are able to quickly transform, store, transport and control cargoes. </p>
              </div>
            </li>
            <li>
              <span></span>
              <div>
                <span>Reliable Quality</span>
                <p>From “box-in and box-out” to “pick and pack”, from the very first of beginning to the very
end “last mile”, Grand Channel provides 360° care for every order.</p>
              </div>
            </li>
            <li>
              <span></span>
              <div>
                <span>Large Capacity</span>
                <p>Our 19,800 square feet warehouse facility possesses 21 busy docks for cargoes in and out.
The designed monthly throughput capacity reaches up to 7,000 tons. </p>
              </div>
            </li>
          </ul>
        </div>
        <div class="logo">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
    </div>
</template>

<script>

  export default {
    name: 'about',
    data () {
      return {

      }
    },
    components:{},
    methods:{

    },
    computed:{

    },
    mounted(){

    },
    watch:{
      // 如果 `某个属性` 发生改变，这个属性对应的函数就会运行
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  h3 {
    font-size:30px;
    color:#0965A4;
    height:40px;
    text-align:center;
  }
  h4 {
    font-size:16px;
    color:#048EEC;
    height:40px;
    text-align:center;
  }

  .about-box {
    width:100%;
    .banner {
      width: 100%;
      height:365px;
      background:url('../../assets/images/about/about.png') no-repeat center top;
      background-size:100% 100%;
    }
    .about {
      padding-top: 100px;
      padding-bottom: 100px;
      width:1000px;
      margin:auto;
      div {
        margin-top:20px;
        p {
          margin-bottom: 20px;
          text-indent:2rem;
          color:#777777;
          font-size:14px;
        }
      }
    }
    .strengths {
      padding-bottom:100px;
      ul {
        display:block;
        width:1000px;
        margin:auto;

        li {
          display:block;
          margin-bottom:20px;
          overflow:hidden;
          >span {
            display:block;
            width:120px;
            height:90px;
            margin-right:18px;
            float: left;
          }
          &:nth-of-type(1){
            >span {
              background:#E6E6E6 url('../../assets/images/home/c1.png') no-repeat center;
              background-size:contain;
            }
          }
          &:nth-of-type(2){
            >span {
              background:#E6E6E6 url('../../assets/images/home/c2.png') no-repeat center;
              background-size:contain;
            }
          }
          &:nth-of-type(3){
            >span {
              background:#E6E6E6 url('../../assets/images/home/c3.png') no-repeat center;
              background-size:contain;
            }
          }
          &:nth-of-type(4){
            >span {
              background:#E6E6E6 url('../../assets/images/home/c4.png') no-repeat center;
              background-size:contain;
            }
          }
          >div {
            width:840px;
            height:90px;
            float: right;
            background-color: #E6E6E6;
            padding: 10px;
            font-size:14px;
            span {
              color:#0965A4;
            }
            p {
              color:#666;
              margin-top:10px;
              line-height:26px;
            }
          }
        }
      }
    }
    .logo {
      overflow:hidden;
      width:900px;
      margin:auto;
      padding-bottom:60px;
      span {
        display:block;
        float:left;
        width:30%;
        height:60px;
        margin-right:3.3%;
        margin-bottom:30px;
        // cursor:pointer;
        &:nth-of-type(1){
          background:url('../../assets/images/about/UPS-LOGO.png') no-repeat left center;
          background-size:contain;
        }
        &:nth-of-type(2){
          background:url('../../assets/images/about/fedex-logo.png') no-repeat left center;
        }
        &:nth-of-type(3){
          background:url('../../assets/images/about/usps-logo.png') no-repeat left center;
          background-size:contain;
        }
        &:nth-of-type(4){
          background:url('../../assets/images/about/fba-logo.png') no-repeat left center;
          background-size:contain;
        }
        &:nth-of-type(5){
          background:url('../../assets/images/about/eccang-logo.png') no-repeat left center;
          background-size:contain;
        }
        &:nth-of-type(6){
          background:url('../../assets/images/about/ebay-logo.png') no-repeat left center;
          background-size:contain;
        }
        &:nth-of-type(7){
          background:url('../../assets/images/about/prime-logo.png') no-repeat left center;
          background-size:contain;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/about/about.vue